<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    filters-title="Ricerca report"
    results-title="Report"
    no-results-message="Nessun report trovato"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <report-filters v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-col v-for="r in page.content" sm="6" md="4">
        <router-link
          class="text-dark"
          style="text-decoration: none;"
          :to="{ name: 'Report', params: { id: r.internalName } }">
          <b-card>
            <div slot="header" class="font-weight-bold">
              {{ r.internalName }}
            </div>
            {{ r.title }}
          </b-card>
        </router-link>
      </b-col>
    </b-row>
    <div slot="bottom-buttons" class="text-right mb-2">
      <b-button variant="success" :to="{ name: 'Report', params: { id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import ReportService from 'app/services/ReportService';
import FindPageMixin from 'vue-core/mixins/FindPageMixin';

export default {
  mixins: [ FindPageMixin ],

  created() {
    this.service = ReportService;
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Report'
        }
      ];
    },

    sorters() {
      return [
        {
          label: 'Nome interno',
          path: 'internalName'
        },
        {
          label: 'Titolo',
          path: 'title'
        },
      ];
    }
  }
}
</script>
